import { memo } from 'react';
import { arrayOf, node, oneOfType, string } from 'prop-types';
import classnames from 'classnames';
import { SecondaryButton } from 'jl-design-system/elements/button/Button';

import styles from './DefaultButton.scss';

export const DefaultButton = memo(({ children, className, ...props }) => (
  <SecondaryButton className={classnames(styles.DefaultButton, className)} {...props}>
    {children}
  </SecondaryButton>
));

DefaultButton.displayName = 'DefaultButton';

DefaultButton.propTypes = {
  children: oneOfType([node, arrayOf(node)]).isRequired,
  className: string,
};
